import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CUSTOMER_DATA_CHANGE_FORM_ROUTE, CUSTOMER_DATA_CHANGE_ROUTE } from '@mwe/constants';
import { Product } from '@mwe/models';
import { CustomerDataChangeStateService } from './customer-data-change-state.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerDataChangeLogic {
  private router = inject(Router);
  private customerDataChangeStateService = inject(CustomerDataChangeStateService);

  startProcessWithAddressSelection(): void {
    this.customerDataChangeStateService.isSelectionVisible = true;
    this.router.navigateByUrl(`/${CUSTOMER_DATA_CHANGE_ROUTE}`);
  }

  startProcessWithoutAddressSelection(products: Product[]): void {
    this.customerDataChangeStateService.products = products;
    this.customerDataChangeStateService.isSelectionVisible = false;
    this.router.navigateByUrl(`/${CUSTOMER_DATA_CHANGE_ROUTE}/${CUSTOMER_DATA_CHANGE_FORM_ROUTE}`);
  }
}
